import React from 'react'
import propTypes from 'prop-types'
import {AsyncSelectField, SelectField} from 'components/selectField'
import {api} from 'services/api'
import {QuoteStatus} from 'helpers/quotes'
import {isNil} from 'lodash'
import './orderSelectField.scss'
import {getOrderOption} from 'helpers/orders'

class OrderSelectField extends React.Component {
  state = {
    orders: null,
  }

  focus = () => {
    this.select.focus()
  }

  componentDidMount() {
    const {companyId} = this.props
    if (companyId) this.setWithCompany(companyId)
  }

  componentDidUpdate(prevProps) {
    const {companyId} = this.props
    if (!isNil(companyId)) {
      if (isNil(prevProps.companyId) || prevProps.companyId !== companyId)
        this.setWithCompany(companyId)
    } else if (!isNil(prevProps.companyId)) {
      this.setWithCompany(null)
    }
  }

  setWithCompany = (companyId) => {
    const {params} = this.props
    if (companyId) {
      // Load orders for company
      this.setState({orders: []})
      api.quote.get({companyId, ...params}, this.getFields()).then(response => {
        api.handleResponseNonYield(
            response,
            (key, data) => {
              this.setState({orders: data.result || []})
            },
            (key, message) => {
              console.error('Failed to load orders for company', message)
            }
        )
      })
    } else {
      this.setState({orders: null})
    }
  }

  getFields = () => {
    const {fields} = this.props
    return {
      ref: true,
      desc: true,
      status: true,
      ...fields,
    }
  }

  getOptions = (orders) => {
    return orders.map(getOrderOption)
  }

  render() {
    const {params, ...otherProps} = this.props
    const {orders} = this.state
    delete otherProps.fields

    if (orders) {
      return <SelectField
          ref={e => this.select = e}
          placeholder="Find a Quote"
          options={this.getOptions(orders)}
          {...otherProps} />
    } else {
      return <AsyncSelectField
          ref={e => this.select = e}
          placeholder="Find a Quote"
          params={params}
          fields={this.getFields()}
          onLoad={api.quote.get}
          onOptions={this.getOptions}
          {...otherProps} />
    }
  }
}

OrderSelectField.propTypes = {
  fields: propTypes.object,
  params: propTypes.object,
  statuses: propTypes.array,
  companyId: propTypes.number,
}

OrderSelectField.defaultProps = {
  params: {
    sortColumn: 'ref',
    sortDirection: 'asc',
    start: 0,
    limit: 10,
    count: true,
    status: [QuoteStatus.draft, QuoteStatus.quoted, QuoteStatus.rejected],
  },
}

export default OrderSelectField
